import { render, staticRenderFns } from "./NotificationIncidenceCard.vue?vue&type=template&id=4c296807&"
import script from "./NotificationIncidenceCard.vue?vue&type=script&lang=js&"
export * from "./NotificationIncidenceCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports